import * as React from 'react';
import { KeyCode } from '@wix/answers-ui-libby';
import ExpandedImage from './expanded-image';
export class ImageComponent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isExpanded: false,
            hideFromDOM: true,
        };
        this.accessibilityCloseExpandedImage = (e) => {
            var _a;
            const isCorrectImg = ((_a = document.querySelector('.image-fullscreen-container.expanded .expanded-img')) === null || _a === void 0 ? void 0 : _a.getAttribute('id')) === this.props.value.src;
            if (e.keyCode === KeyCode.ESCAPE || e.keyCode === KeyCode.ENTER) {
                if (document.querySelector('.image-fullscreen-container.expanded') && isCorrectImg) {
                    this.setState({ isExpanded: false }, this.hideWithTimeout);
                }
                if (this.imgRef && isCorrectImg) {
                    this.imgRef.focus();
                }
            }
        };
        this.accessibilityExpandImage = (e) => {
            if (e.keyCode === KeyCode.ENTER && !this.state.isExpanded) {
                this.onImgClick();
                setTimeout(() => {
                    const ImgElement = document.querySelector('.expanded-img');
                    if (document.querySelector('.image-fullscreen-container.expanded') && ImgElement) {
                        ImgElement.focus();
                    }
                }, 200);
            }
        };
        this.onImgAccessibilityClick = () => {
            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }
        };
        this.onExpandedAccessibilityKeyup = (e) => {
            if (e.keyCode === KeyCode.ENTER) {
                this.setState({ isExpanded: false }, this.hideWithTimeout);
                const ImgElement = document.querySelector('img.clickable');
                if (ImgElement) {
                    ImgElement.focus();
                }
            }
        };
        this.setImgRef = (elem) => {
            if (elem) {
                this.imgRef = elem;
                elem.addEventListener('keyup', this.accessibilityExpandImage);
                elem.addEventListener('click', this.onImgAccessibilityClick);
            }
        };
        this.onImgClick = () => {
            const showWithTimeout = () => setTimeout(() => this.setState({ isExpanded: true }), 100);
            const { props } = this;
            if (!props.value.link) {
                if (props.onImgClick) {
                    props.onImgClick(props.value.src);
                }
                else {
                    this.setState({ hideFromDOM: false }, showWithTimeout);
                }
            }
        };
        this.setExpandImgRef = (elem) => {
            if (elem) {
                this.expandedRef = elem;
                elem.addEventListener('keyup', this.onExpandedAccessibilityKeyup);
            }
        };
        this.hideWithTimeout = () => setTimeout(() => this.setState({ hideFromDOM: true }), 100);
    }
    componentWillUnmount() {
        window.removeEventListener('keyup', this.accessibilityCloseExpandedImage);
        if (this.imgRef) {
            this.imgRef.removeEventListener('keyup', this.accessibilityExpandImage);
            this.imgRef.removeEventListener('click', this.onImgAccessibilityClick);
        }
        if (this.expandedRef) {
            this.expandedRef.removeEventListener('keyup', this.onExpandedAccessibilityKeyup);
        }
    }
    componentDidMount() {
        window.addEventListener('keyup', this.accessibilityCloseExpandedImage);
    }
    maybeLinkedImage() {
        const props = this.props;
        const { value } = this.props;
        const clickable = !props.value.link ? 'clickable' : '';
        const renderedImage = (React.createElement("img", { tabIndex: 0, id: value.src, ref: this.setImgRef, className: clickable, src: value.src, alt: value.alt || '', onClick: this.onImgClick, loading: props.index > 1 ? 'lazy' : 'eager' }));
        const linkedImage = React.createElement("a", { href: props.value.link, target: '_blank' }, renderedImage);
        return props.value.link ? linkedImage : renderedImage;
    }
    render() {
        const props = this.props;
        const onDismiss = () => {
            this.setState({ isExpanded: false }, this.hideWithTimeout);
        };
        return (React.createElement("div", { className: 'component image-component', "data-component-type": 'image' },
            React.createElement("div", { className: 'image-container' }, this.maybeLinkedImage()),
            React.createElement(ExpandedImage, { value: props.value, isExpanded: this.state.isExpanded, setExpandImgRef: this.setExpandImgRef, hideFromDOM: this.state.hideFromDOM, onDismiss: onDismiss })));
    }
}
